import React from "react";
import { View } from "react-native";
import { t } from "react-native-tailwindcss";
import { useQueryClient } from "react-query";
import { useToast } from "react-native-toast-notifications";
import { ExtraLargeText } from "../../../atoms/ExtraLargeText";
import { ScreenContainer } from "../../../layout/ScreenContainer";
import Button from "../../../atoms/Button";
import { HCenterStack } from "../../../layout/HStack";
import { MediumText } from "../../../atoms/MediumText";
import { finishOnboarding } from "../../../../services/userService";
import { QueryKey } from "../../../../services/api/query";
import { getErrorMessage } from "../../../../services/api/api";

export const FinishOnboardingScreen = (): React.ReactElement => {
  const queryClient = useQueryClient();
  const toast = useToast();

  return (
    <ScreenContainer center>
      <HCenterStack>
        <ExtraLargeText center>You're all done!</ExtraLargeText>
      </HCenterStack>
      <MediumText>
        Use the app to manage your round-ups and watch your progress!
      </MediumText>

      <View style={styles.buttonContainer}>
        <Button
          label="Go to the dashboard"
          onPress={async () => {
            try {
              await finishOnboarding();
              queryClient.invalidateQueries(QueryKey.User);

              // eslint-disable-next-line @typescript-eslint/ban-ts-comment
              // @ts-ignore
            } catch (error: Error & ApiError) {
              console.log(getErrorMessage(error));
              toast.show("Something went wrong", {
                type: "danger",
              });
            }
          }}
        />
      </View>
    </ScreenContainer>
  );
};

const styles = {
  buttonContainer: [{ width: 200, marginTop: 20 }, t.mLAuto, t.mRAuto],
};
